<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/ticket/pendingTicket")
          i.fas.fa-list-alt
          span.ml-1 {{ $t("ui.pending_ticket") }}
  b-card(body-class="").p-0
    div(slot="header")
      div.row.col-md-12.mb-1
        div(width="10%").mr-3
          SubmitButton(:loading="loading" icon="icon-reload" :text="$t('ui.refresh')" @click="getTicketList" size="sm" variant="info")
        div(width="65%").mr-3
          b-input-group(size="sm").mb-1
            b-input-group-text(slot="prepend")
              div.d-flex.justify-content-center.align-items-center
                label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                  input.switch-input(type="checkbox" v-model="$options.refreshOn" @change="toggleRefresh()")
                  span.switch-slider(:data-checked='on' :data-unchecked='off')
            b-input(v-model="refreshInterval" type="range" min="1" max="5")
            b-input-group-text(slot="append")
              div(style="text-transform: none;") {{ refreshInterval }} s
        div(width="15%").mr-3
          b-input-group(size="sm").mb-1
            b-input-group-text(slot="prepend")
              span {{ $t('ui.alert') }}
            b-input-group-text(slot="append")
              div.d-flex.justify-content-center.align-items-center
                label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                  input.switch-input(type="checkbox" v-model="alert")
                  span.switch-slider(:data-checked='on' :data-unchecked='off')
        div(width="10%")
          SubmitButton(
            ref="search_btn"
            :loading="loading"
            icon="fa fa-search"
            :text="$t('ui.search')"
            type="button"
            @click="getTicketList()"
            variant="success"
            size="sm"
            )
      div.row.col-md-12.mb-1
        div(width="20%").mr-3
          b-input-group(size="sm")
            b-input-group-text(slot="prepend")
              i.icon-user
            DebounceInput(type="text" v-model="search" :placeholder="$t('message.search_by_id')" @enter="getTicketList()")
    b-tabs(small card)
      b-tab(title-link-class="small-link" title-item-class="small-item")
        template(slot="title")
          span(style="padding: 1px; line-height: 16px;") {{ $t("ui.deposit") }}
          b-badge(variant="danger" size="sm" style="width: 30px; vertical-align: top;").ml-1 {{ depTotalRow }}
        div.d-flex.flex-wrap
          div.clusterize
            div.row.mb-1
              div.col-md-10
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="depTotalRow"
                  :per-page="getPageSize"
                  v-model="currentDepPage"
                  @input="changedDepPage($event)").mb-1
              div.col-md-2
                b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedDepPageSize")
            .clusterize-scroll
              table.tablex(style="width: 100%")
                thead
                  tr
                    th.sticky-position(width="3%")
                      span #
                    th.sticky-position(width="5%")
                      span(:title="$t('ui.id')") {{ $t('ui.id') }}
                    th.sticky-position.sortable(width="8%" @click="sortOrder('member_id', 'dep')")
                      span(:title="$t('ui.member')") {{ $t('ui.member') }}
                      i(:class="changeSortKey('member_id', 'dep')")
                    th.sticky-position.sortable(width="5%" @click="sortOrder('target_bank_id', 'dep')")
                      span(:title="$tc('ui.banks', 1)") {{ $tc('ui.banks', 1) }}
                      i(:class="changeSortKey('target_bank_id', 'dep')")
                    th.sticky-position.sortable(width="8%" @click="sortOrder('target_bank_acc_no', 'dep')")
                      span(:title="$t('ui.bank_acc_no')") {{ $t('ui.bank_acc_no') }}
                      i(:class="changeSortKey('target_bank_acc_no', 'dep')")
                    th.sticky-position(width="8%")
                      span(:title="$t('ui.bank_acc_holder')") {{ $t('ui.bank_acc_holder') }}
                    th.sticky-position.sortable(width="8%" @click="sortOrder('amount', 'dep')")
                      span(:title="$t('ui.amount')") {{ $t('ui.amount') }}
                      i(:class="changeSortKey('amount', 'dep')")
                    th.sticky-position.sortable(width="6%" @click="sortOrder('promotion_id', 'dep')")
                      span(:title="$t('ui.promo')") {{ $t("ui.promo") }}
                      i(:class="changeSortKey('promotion_id', 'dep')")
                    th.sticky-position.sortable(width="6%" @click="sortOrder('bonus_amount', 'dep')")
                      span(:title="$t('ui.bonus_amount')") {{ $t("ui.bonus_amount") }}
                      i(:class="changeSortKey('bonus_amount', 'dep')")
                    th.text-center.sticky-position(width="11%")
                      span(:title="$t('ui.action')") {{ $t("ui.action") }}
                    th.text-right.sticky-position.sortable(width="10%" @click="sortOrder('created_date', 'dep')")
                      span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                      i(:class="changeSortKey('created_date', 'dep')")
                tbody.clusterize-content
                  tr(v-if="depositList.length == 0")
                    td(:colspan="11").text-center
                      span {{ $t('message.no_data_available') }}
                  tr(v-for="(item, index) in depositList" :class="$helpers.rowClassTicket(item)")
                    td
                      span(:title="((currentDepPage - 1) * getPageSize + index + 1)") {{ ((currentDepPage - 1) * getPageSize + index + 1) }}
                    td
                      span(:title="item.id") {{ item.id }}
                    td
                      span.font-weight-bold(:title="item.member_id")
                        b-link.clickable(href="javascript:void(0);" @click="onInfo(item)") {{ item.member_id }}
                    td
                      span(:title="item.target_bank_id") {{ item.target_bank_id }}
                    td
                      span(:title="item.target_bank_acc_no") {{ item.target_bank_acc_no }}
                    td
                      span(:title="item.target_bank_acc_holder") {{ item.target_bank_acc_holder }}
                    td
                      span(:title="$n(item.amount, 'currency')") {{ $n(item.amount, 'currency') }}
                    td
                      span(:title="item.promotion_id") {{ item.promotion_id }}
                    td
                      span(:title="$n(item.bonus_amount, 'currency')") {{ $n(item.bonus_amount, 'currency') }}
                    td.actions
                      span(v-if="item.status.trim().toUpperCase() != 'PENDING'")
                        a.fa.fa-search.text-primary(href="javascript:void(0)" @click="getTicketDetail(item, $event)" :title="$t('ui.view')")
                      span(v-if="item.attachment_path")
                        a.fa.fa-paperclip.text-primary(href="javascript:void(0)" @click="openAttachment(item)" :title="$t('ui.attachment')")
                      span(v-if="item.status.trim().toUpperCase() == 'PENDING'")
                        a.fa.fa-check.text-secondary(href="javascript:void(0)" @click="approveTicket(item, $event)" :title="$t('ui.approve')")
                      span(v-if="item.status.trim().toUpperCase() == 'PENDING'")
                        a.fa.fa-ban.text-danger(href="javascript:void(0)" @click="rejectTicket(item, $event)" :title="$t('ui.reject')")
                    td.text-right
                      span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
      b-tab(title-link-class="small-link" title-item-class="small-item")
        template(slot="title")
          span(style="padding: 1px; line-height: 16px;") {{ $t("ui.withdrawal") }}
          b-badge(variant="danger" size="sm" style="width: 30px; vertical-align: top;").ml-1 {{ wdwTotalRow }}
        div.d-flex.flex-wrap
          div.clusterize
            div.row.mb-1
              div.col-md-10
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="wdwTotalRow"
                  :per-page="getPageSize"
                  v-model="currentWdwPage"
                  @input="changedWdwPage($event)").mb-1
              div.col-md-2
                b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedWdwPageSize")
            .clusterize-scroll
              table.tablex(style="width: 100%;")
                thead
                  tr
                    th.sticky-position(width="3%")
                      span #
                    th.sticky-position(width="5%")
                      span(:title="$t('ui.id')") {{ $t('ui.id') }}
                    th.sticky-position.sortable(width="8%" @click="sortOrder('member_id', 'wdw')")
                      span(:title="$t('ui.member')") {{ $t('ui.member') }}
                      i(:class="changeSortKey('member_id', 'wdw')")
                    th.sticky-position.sortable(width="7%" @click="sortOrder('amount', 'wdw')")
                      span(:title="$t('ui.amount')") {{ $t('ui.amount') }}
                      i(:class="changeSortKey('amount', 'wdw')")
                    th.sticky-position.sortable(width="5%" @click="sortOrder('target_bank_id', 'wdw')")
                      span(:title="$tc('ui.banks', 1)") {{ $tc('ui.banks', 1) }}
                      i(:class="changeSortKey('target_bank_id', 'wdw')")
                    th.sticky-position.sortable(width="8%" @click="sortOrder('target_bank_acc_no', 'wdw')")
                      span(:title="$t('ui.bank_acc_no')") {{ $t("ui.bank_acc_no") }}
                      i(:class="changeSortKey('target_bank_acc_no', 'wdw')")
                    th.sticky-position(width="8%")
                      span(:title="$t('ui.rejected_ticket_id')") {{ $t("ui.short.rejected_ticket_id") }}
                    th.text-center.sticky-position(width="8%")
                      span(:title="$t('ui.action')") {{ $t("ui.action") }}
                    th.text-right.sticky-position.sortable(width="10%" @click="sortOrder('created_date', 'wdw')")
                      span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                      i(:class="changeSortKey('created_date', 'wdw')")
                tbody.clusterize-content
                  tr(v-if="withdrawalList.length == 0")
                    td(:colspan="9").text-center
                      span {{ $t('message.no_data_available') }}
                  tr(v-for="(item, index) in withdrawalList")
                    td
                      span(:title="((currentWdwPage - 1) * getPageSize + index + 1)") {{ ((currentWdwPage - 1) * getPageSize + index + 1) }}
                    td
                      span(:title="item.id") {{ item.id }}
                    td
                      span.font-weight-bold(:title="item.member_id")
                        b-link.clickable(href="javascript:void(0);" @click="onInfo(item)") {{ item.member_id }}
                    td
                      span(:title="$n(item.amount, 'currency')") {{ $n(item.amount, 'currency') }}
                    td
                      span(:title="item.target_bank_id") {{ item.target_bank_id }}
                    td
                      span(:title="item.target_bank_acc_no") {{ item.target_bank_acc_no }}
                    td
                      span(:title="item.rejected_ticket_id") {{ item.rejected_ticket_id }}
                    td.actions
                      span
                        a.fas.fa-poll.text-info(href="javascript:void(0)" @click="onGetRecentDeposit(item)" :title="$t('ui.get_recent_deposit')")
                      span(v-if="item.status.trim().toUpperCase() != 'PENDING'")
                        a.fa.fa-search.text-primary(href="javascript:void(0)" @click="getTicketDetail(item)" :title="$t('ui.view')")
                      span(v-if="item.status.trim().toUpperCase() == 'PENDING'")
                        a.fa.fa-check.text-secondary(href="javascript:void(0)" @click="approveTicket(item, $event)" :title="$t('ui.settle')")
                      span(v-if="item.status.trim().toUpperCase() == 'PENDING'")
                        a.fa.fa-paper-plane.text-success(href="javascript:void(0)" @click="submitTicket(item, $event)" :title="$t('ui.submit_pg')")
                      span(v-if="item.status.trim().toUpperCase() == 'PENDING'")
                        a.fa.fa-ban.text-danger(href="javascript:void(0)" @click="rejectTicket(item, $event)" :title="$t('ui.reject')")
                    td.text-right
                      span(v-if="item.created_date" :title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
    ticketdetail(ref="ticketdetail" :ticketId="selectedTicketId" @failed="handleFailed")
    approveticket(ref="approveticket" :ticketId="selectedTicketId" :parentId="selectedParentId" :memberId="selectedMemberId" @clicked="afterEditTicket" @failed="handleFailed")
    rejectticket(ref="rejectticket" :ticketId="selectedTicketId" @clicked="afterEditTicket" @failed="handleFailed")
    getrecentdeposit(ref="getrecentdeposit" :item="editSelectedMember" @failed="handleFailed")
    memberdetails(ref="memberdetails" :memberId="selectedMemberId" @failed="handleFailed")
    submitticketpg(ref="submitticketpg" :ticketId="selectedTicketId" @clicked="afterSubmitTicket" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import ticketdetail from "@/components/ticket/ticketDetail.vue";
import approveticket from "@/components/ticket/approveTicket.vue";
import rejectticket from "@/components/ticket/rejectTicket.vue";
import getrecentdeposit from "@/components/ticket/getRecentDeposit.vue";
import memberdetails from "@/components/member/memberDetails.vue";
import submitticketpg from "@/components/ticket/submitTicketPG.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    ticketdetail,
    approveticket,
    rejectticket,
    getrecentdeposit,
    memberdetails,
    submitticketpg
  },
  data: () => ({
    loading: false,
    depositList: [],
    withdrawalList: [],
    currentDepPage: 1,
    currentWdwPage: 1,
    depTotalRow: 0,
    wdwTotalRow: 0,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    requestType: null,
    ticketTimer: null,
    refreshInterval: 5,
    refreshChange: "",
    selectedTicketId: null,
    selectedTicket: null,
    selectedParentId: null,
    selectedMemberId: null,
    depSortKey: "id",
    depSortType: "desc",
    wdwSortKey: "id",
    wdwSortType: "desc",
    al: null,
    search: '',
    editSelectedMember: null,
    editSelectedMemberId: ""
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    alert:
    {
      get() {
        return this.$store.getters.alertOn;
      },
      set(value) {
        this.changedAlertOn(value);
      }
    }
  },
  created: function() {
    this.$options.refreshOn = false;
  },
  mounted: function() {
    this.getTicketList();
  },
  destroyed: function() {
    if (this.ticketTimer) {
      clearTimeout(this.ticketTimer);
    }
  },
  methods: {
    changedAlertOn: function(eventStatus) {
      this.$store.dispatch("user/setAlertOn", eventStatus);
    },
    sortOrder(key, type) {
      if (type == 'dep') {
        if (this.depSortKey == key)
          this.depSortType = this.depSortType == 'asc' ? 'desc' : 'asc';
        else {
          this.depSortKey = key;
          this.depSortType = 'asc';
        }

        this.getDepositList(true);
      } else if (type == 'wdw') {
        if (this.wdwSortKey == key)
          this.wdwSortType = this.wdwSortType == 'asc' ? 'desc' : 'asc';
        else {
          this.wdwSortKey = key;
          this.wdwSortType = 'asc';
        }

        this.getWithdrawalList(true);
      }
    },
    changeSortKey(key, type) {
      if (type == 'dep') {
        if (this.depSortKey != key)
          return 'fas fa-sort';
        else if (this.depSortKey == key && this.depSortType == 'asc')
          return 'fa fa-sort-up';
        else if (this.depSortKey == key && this.depSortType == 'desc')
          return 'fa fa-sort-down';
      } else if (type == 'wdw') {
        if (this.wdwSortKey != key)
          return 'fas fa-sort';
        else if (this.wdwSortKey == key && this.wdwSortType == 'asc')
          return 'fa fa-sort-up';
        else if (this.wdwSortKey == key && this.wdwSortType == 'desc')
          return 'fa fa-sort-down';
      }
    },
    onInfo(e) {
      this.selectedMemberId = e.member_id;
      this.$refs.memberdetails.$refs.memberDetails.show();
    },
    onGetRecentDeposit(e) {
      this.editSelectedMember = e;
      this.$refs.getrecentdeposit.$refs.getRecentDeposit.show();
    },
    getTicketList() {
      this.getDepositList(true);
      this.getWithdrawalList(true);
    },
    openAttachment(obj) {
      this.$store.dispatch("user/setAttachmentPath", obj.attachment_path);
      let routeData = this.$router.resolve({path: '/attachment'});
      window.open(routeData.href, '_blank', "toolbar=yes,scrollbars=yes,resizable=yes,top=100,left=250,width=1500,height=800");
    },
    getDepositList: function(isSearch) {
      let url = config.ticketListPendingUrl();

      if (isSearch) this.currentDepPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        request_type: 'DEPOSIT',
        sort_key: this.depSortKey,
        sort_type: this.depSortType,
        page_number: this.currentDepPage,
        page_size: this.getPageSize
      };

      if (this.search.trim() != '')
        json.member_id = this.search;

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.depositList = response.data.dt;
                this.depTotalRow = this.depositList.length > 0 ? this.depositList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getWithdrawalList: function(isSearch) {
      let url = config.ticketListPendingUrl();

      if (isSearch) this.currentWdwPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        request_type: 'WITHDRAWAL',
        sort_key: this.wdwSortKey,
        sort_type: this.wdwSortType,
        page_number: this.currentWdwPage,
        page_size: this.getPageSize
      };

      if (this.search.trim() != '')
        json.member_id = this.search;

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.withdrawalList = response.data.dt;
                this.wdwTotalRow = this.withdrawalList.length > 0 ? this.withdrawalList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getTicketDetail: function(e) {
      this.selectedTicketId = e.id;
      this.$refs.ticketdetail.$refs.ticketDetail.show();
    },
    afterEditTicket: function(type, afterBalance) {
      this.getTicketList();

      if (type == 1) {
        this.$swal({
          title: this.$t("ui.combine.edit_ticket"),
          html:
            "<div>" +
            this.$t("ui.after_balance") +
            ": <strong>" +
            this.$n(afterBalance, 'currency') +
            "</strong></div>",
          type: "success",
          confirmButtonText: this.$t("ui.ok"),
          allowOutsideClick: false
        }).then(isConfirm => {
          if (isConfirm.value) {

          }
        });
      } else
        this.$helpers.showDialog(this.$t("ui.combine.edit_ticket"), this.$t("message.success"), "success");
    },
    afterSubmitTicket: function() {
      this.getTicketList();
      this.$helpers.showDialog(this.$t("ui.combine.submit_pg"), this.$t("message.success"), "success");
    },
    approveTicket: function(e) {
      this.selectedTicketId = e.id;
      this.selectedParentId = e.parent_id;
      this.selectedMemberId = e.member_id;
      this.$refs.approveticket.$refs.approveTicket.show();
    },
    rejectTicket: function(e) {
      this.selectedTicketId = e.id;
      this.$refs.rejectticket.$refs.rejectTicket.show();
    },
    submitTicket: function(e) {
      this.selectedTicketId = e.id;
      this.selectedParentId = e.parent_id;
      this.selectedMemberId = e.member_id;
      this.$refs.submitticketpg.$refs.submitTicketPG.show();
    },
    toggleRefresh: function() {
      this.startRefreshTimer();
    },
    startRefreshTimer: function() {
      if (this.ticketTimer) {
        clearTimeout(this.ticketTimer);
      }
      if (this.$options.refreshOn) {
        this.getTicketList();
        this.ticketTimer = setTimeout(() => {
          this.startRefreshTimer();
        }, this.refreshInterval * 1000);
      } else {
        this.refreshChange = "STOPPED";
      }
    },
    changedDepPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentDepPage = 1;
      this.getDepositList(true);
    },
    changedDepPage: function(pageNo) {
      this.currentDepPage = pageNo;
      this.getDepositList();
    },
    changedWdwPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentWdwPage = 1;
      this.getWithdrawalList(true);
    },
    changedWdwPage: function(pageNo) {
      this.currentWdwPage = pageNo;
      this.getWithdrawalList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>